import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  private renderer: Renderer2;
  private splashScreen: HTMLElement | null = null;
  rendererFactory = inject(RendererFactory2);

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  private getSplashScreen(): HTMLElement | null {
    if (!this.splashScreen) {
      this.splashScreen = this.renderer.selectRootElement('#splashScreen', true);
    }
    return this.splashScreen;
  }

  show(): void {
    const splash = this.getSplashScreen();
    if (splash) {
      this.renderer.setStyle(splash, 'display', 'block');
    }
  }

  hide(): void {
    const splash = this.getSplashScreen();
    if (splash) {
      this.renderer.setStyle(splash, 'display', 'none');
    }
  }
}
